import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ru from './ru.json';

// Все тексты интерфейса — в файлах переводов. Чтобы добавить казахский,
// достаточно положить kk.json рядом и добавить его в resources.
void i18n.use(initReactI18next).init({
  resources: { ru: { translation: ru } },
  lng: 'ru',
  fallbackLng: 'ru',
  initAsync: false,
  interpolation: { escapeValue: false },
});

export default i18n;
